import './index.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache'
import 'sweetalert2/dist/sweetalert2.min.css';
import GetAuthLog from './shared/api/getAuthLog';
import { Success } from "./constants";

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);

let authComp = false;
let error = false;

const nonce = '66cbd3e1528ac2f5fe1017ba27e73b943a6edac47465a670beddfc7d35806bad';
const cache = createCache({
    key: 'css',
    nonce: nonce
});
// ローカルストレージチェック
const contractId = localStorage.getItem('contractId');
if (contractId) {
    // 認証ログ取得APIの呼び出し
    GetAuthLog(contractId).then(data => {
        console.log(data)
        if (data.resCd === Success) {
            if (data.data.cnt > 0) {
                authComp = true;
                root.render(
                    <React.StrictMode>
                        <CacheProvider value={cache}>
                            <App authComp={authComp} error={error} />
                        </CacheProvider>
                    </React.StrictMode>
                );
            } else {
                root.render(
                    <React.StrictMode>
                        <CacheProvider value={cache}>
                            <App authComp={authComp} error={error} />
                        </CacheProvider>
                    </React.StrictMode>
                );
            }
        } else {
            error = true;
            root.render(
                <React.StrictMode>
                    <CacheProvider value={cache}>
                        <App authComp={authComp} error={error} />
                    </CacheProvider>
                </React.StrictMode>
            );
        }
    });
} else {
    root.render(
        <React.StrictMode>
            <CacheProvider value={cache}>
                <App authComp={authComp} error={error} />
            </CacheProvider>
        </React.StrictMode>
    );
}
